import { Role } from 'src/types';

// Reusable role groups — the single source of truth for every route's
// allowList. Both `RootRouter` (route guards) and `Sidebar` (menu config)
// must read from `routeAccess` so the guard and the menu can never drift
// (a menu item showing a route the guard denies, or vice-versa).
const SUPER_SUPPORT: Role[] = [Role.SuperAdmin, Role.Support];
const STANDARD_ADMINS: Role[] = [Role.SuperAdmin, Role.Support, Role.Analyst, Role.ClientAdmin];
const ALL_PRODUCT_ROLES: Role[] = [
  Role.SuperAdmin,
  Role.Support,
  Role.Analyst,
  Role.ClientAdmin,
  Role.Manager,
];

// Keys correspond to `RoutePath` members. Lookups are membership-based, so
// array order is not significant for guard/menu behaviour.
export const routeAccess = {
  // Top-level guarded branches (consumed by RootRouter)
  configurationRoot: ALL_PRODUCT_ROLES,
  dataManagementRoot: ALL_PRODUCT_ROLES,
  reportingRoot: ALL_PRODUCT_ROLES,
  productInfo: SUPER_SUPPORT,

  // Configuration — children
  configurationParametersRoot: STANDARD_ADMINS,
  configurationValidationsRoot: ALL_PRODUCT_ROLES,
  configurationScoringDefinitionRoot: STANDARD_ADMINS,

  // Reporting — children
  reportingTemplatesRoot: STANDARD_ADMINS,
  reportingHistoryRoot: ALL_PRODUCT_ROLES,
};
